import React, { createContext, useContext, useState, ReactNode } from "react";

interface ModalContextType {
  modalType: string | null;
  modalProps: any;
  showModal: (modalType: string, modalProps?: any) => void;
  hideModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [modalType, setModalType] = useState<string | null>(null);
  const [modalProps, setModalProps] = useState<any>({});

  const showModal = (type: string, props: any = {}) => {
    setModalType(type);
    setModalProps(props);
  };

  const hideModal = () => {
    setModalType(null);
    setModalProps({});
  };

  return (
    <ModalContext.Provider value={{ modalType, modalProps, showModal, hideModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
